import React from 'react'

const Experience = () => {
    return (
        <div className="experience">
            <div className="d-flex justify-content-center my-5">
                <h1>experience</h1>
            </div>
            <div className="container experience-wrapper">
                <div className="timeline-block timeline-block-right" >
                    <div className="marker">

                    </div>
                    <div className="timeline-content">
                        <h3>2018-2019</h3>
                        <p>Hemant Kumar, being a big knowledge seeker and a graphic designer has got a stunning About me page that immediately shows if he is ready for the new projects including web & print design, as well as branding. The webpage has a pleasant color scheme: arrows and characters of orange color look cool on the lovely light gray ground, and the owl image shows his hunger for illustrations.</p>
                    </div>
                </div>
                {/*--- */}

                <div className="timeline-block timeline-block-left" >
                    <div className="marker">

                    </div>
                    <div className="timeline-content">
                        <h3>2019-2020</h3>
                        <p>Hemant Kumar, being a big knowledge seeker and a graphic designer has got a stunning About me page that immediately shows if he is ready for the new projects including web & print design, as well as branding. The webpage has a pleasant color scheme: arrows and characters of orange color look cool on the lovely light gray ground, and the owl image shows his hunger for illustrations.</p>
                    </div>
                </div>

                 {/*--- */}

                 <div className="timeline-block timeline-block-right" >
                    <div className="marker">

                    </div>
                    <div className="timeline-content">
                        <h3>2020-2021</h3>
                        <p>Hemant Kumar, being a big knowledge seeker and a graphic designer has got a stunning About me page that immediately shows if he is ready for the new projects including web & print design, as well as branding. The webpage has a pleasant color scheme: arrows and characters of orange color look cool on the lovely light gray ground, and the owl image shows his hunger for illustrations.</p>
                    </div>
                </div>

                 {/*--- */}

                 <div className="timeline-block timeline-block-left" >
                    <div className="marker">

                    </div>
                    <div className="timeline-content">
                        <h3>2018-2021</h3>
                        <p>Hemant Kumar, being a big knowledge seeker and a graphic designer has got a stunning About me page that immediately shows if he is ready for the new projects including web & print design, as well as branding. The webpage has a pleasant color scheme: arrows and characters of orange color look cool on the lovely light gray ground, and the owl image shows his hunger for illustrations.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Experience